import { FC } from 'react'
import { Box, IconButton, Typography } from '@mui/material'

/* Components */
import { Container } from './jiraHeader.styles'
import BetaIntegrationMarker from '../components/BetaIntegrationMarker'

interface Props {
  headerTitle: string
  handleBack: () => void
}

/* The wizard's title bar. It carries no actions — the step footer owns them. */
const JiraHeader: FC<Props> = ({ headerTitle, handleBack }) => (
  <Container>
    <Box className="wrapper">
      <Box className="back-arrow-wrapper">
        <IconButton onClick={handleBack}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="-6.5 8 24 24" fill="none">
            <path d="M9 27.5L2 20L9 12.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </IconButton>
      </Box>

      <Box className="header-content">
        <Typography className="header-title">{headerTitle}</Typography>
        <BetaIntegrationMarker expanded={false} />
      </Box>
    </Box>
  </Container>
)

export default JiraHeader
